import { AxiosInstance, AxiosError } from 'axios';
import { HttpError } from './http-error';
import { redirectToMidwayLogin } from './midway';

export function setupInterceptors(client: AxiosInstance): void {
  client.interceptors.response.use(
    (response) => {
      if (isCoralError(response.data)) {
        return handleCoralError(response.data);
      }

      return response;
    },
    (error: AxiosError) => {
      if (error.response) {
        const { status, data } = error.response;

        if (status === 401) {
          redirectToMidwayLogin();
          return Promise.reject(new HttpError(401, 'Unauthorized'));
        }

        const message = (data as { message?: string })?.message || error.message || 'An error occurred';

        return Promise.reject(new HttpError(status, message, data));
      }

      if (error.request) {
        return Promise.reject(new HttpError(0, 'Network error'));
      }

      return Promise.reject(new HttpError(0, error.message));
    },
  );
}

function isCoralError(data: any): boolean {
  return data?.Output?.__type !== undefined;
}

function getStatusFromCoralError(errorType: string): number {
  if (errorType.includes('NotFound')) {
    return 404;
  }
  if (errorType.includes('ValidationException') || 
      errorType.includes('InvalidParameterException') ||
      errorType.includes('InvalidInput')) {
    return 400;
  }
  if (errorType.includes('UnauthorizedException') || 
      errorType.includes('AccessDeniedException') ||
      errorType.includes('Forbidden')) {
    return 403;
  }
  
  if (errorType.includes('DependencyException') || 
      errorType.includes('ServiceUnavailable')) {
    return 503;
  }
  if (errorType.includes('ThrottlingException') || 
      errorType.includes('TooManyRequests')) {
    return 429;
  }

  console.warn('Unknown Coral error type:', errorType);
  return 500;
}

function handleCoralError(data: any): Promise<never> {
  const errorType = data.Output.__type;
  const message = data.Output.message || errorType;
  const status = getStatusFromCoralError(errorType);
  
  return Promise.reject(new HttpError(status, message, data));
}